<script lang="ts" setup>
import { NewProduct } from '@/types/api/api-v4/product'

import ProductCard from '@/components/Product/ProductCard/ProductCard.vue'
import ProductModal from '@/components/Product/ProductModal.vue'

type Props = {
  products: NewProduct[]
  isLoading?: boolean
}

const props = defineProps<Props>()

const { productDialog, openDialogProduct, closeDialogProduct } =
  useProductModal()

const onOpenDialogProduct = (product: NewProduct) => {
  openDialogProduct({
    currentProduct: product,
    productList: props.products,
    visible: true,
  })
}
</script>

<template>
  <div class="product-list">
    <slot />

    <product-card
      v-for="product in products"
      :key="product.id"
      :product="product"
      :is-loading="isLoading"
      @on-open-dialog="onOpenDialogProduct"
    />

    <product-modal
      :product-dialog="productDialog"
      @close-dialog-product="closeDialogProduct"
    />
  </div>
</template>

<style lang="scss" scoped>
.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, 276px);
  gap: 100px 32px;

  @include media('<=portrait-phone', '>=phone') {
    grid-template-columns: repeat(2, minmax(145px, 1fr));
    gap: 10px;
    padding: 25px 0 0;
  }

  @include media('<=tablet', '>=portrait-phone') {
    grid-template-columns: repeat(2, minmax(120px, 225px));
    gap: 10px;
    padding: 25px 0 0;
  }

  // Границы ширины [от 768 до 1024]
  @include media('>=tablet', '<=desktop-mini') {
    grid-template-columns: repeat(3, minmax(217px, 1fr));
    gap: 10px;
    padding: 25px 0 0;
  }
}
</style>
